"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSubmitted = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var styles_1 = require("../../../styles");
var Components_1 = require("../Components");
var HiArrowCircleUp_1 = require("@react-icons/all-files/hi/HiArrowCircleUp");
var hooks_1 = require("../hooks");
var context_1 = require("../../../context/context");
var hooks_2 = require("../../../hooks");
function OrderSubmitted() {
    var createOrdertxHash = (0, context_1.useTwapContext)().state.createOrdertxHash;
    var explorerUrl = (0, hooks_2.useExplorerUrl)();
    return ((0, jsx_runtime_1.jsxs)(StyledContainer, __assign({ className: "twap-create-order-submitted" }, { children: [(0, jsx_runtime_1.jsx)(Logo, __assign({ className: "twap-create-order-submitted-logo" }, { children: (0, jsx_runtime_1.jsx)(HiArrowCircleUp_1.HiArrowCircleUp, {}) })), (0, jsx_runtime_1.jsx)(Title, {}), (0, jsx_runtime_1.jsx)(Components_1.SmallTokens, {}), createOrdertxHash && (0, jsx_runtime_1.jsx)(Components_1.Link, __assign({ href: "".concat(explorerUrl, "/tx/").concat(createOrdertxHash) }, { children: "View explorer" }))] })));
}
exports.OrderSubmitted = OrderSubmitted;
var Logo = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    svg: {
        width: 70,
        height: 70,
    },
});
var Title = function () {
    var type = (0, hooks_1.useOrderType)();
    return (0, jsx_runtime_1.jsxs)(styles_1.StyledText, __assign({ className: "twap-create-order-submitted-title" }, { children: [type, " order submitted"] }));
};
var StyledContainer = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    gap: 15,
    alignItems: "center",
    ".twap-order-modal-submitted-title": {
        fontSize: 16,
    },
    ".twap-order-modal-link": {
        marginTop: 30,
    },
});
